import React from 'react';

export default function LangSelect({ lang, setLang, LANGS, variant = 'select' }) {
  const current = LANGS.find((l) => l.code === lang) || LANGS[0];

  if (variant === 'icon') {
    return (
      <button
        type="button"
        onClick={() => {
          const index = LANGS.findIndex((l) => l.code === lang);
          const next = LANGS[(index + 1) % LANGS.length];
          setLang(next.code);
        }}
        className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-slate-300 bg-white text-xs font-semibold text-slate-700 hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 transition-colors"
        aria-label="Change language"
        title={current.label}
      >
        {current.code.toUpperCase()}
      </button>
    );
  }

  return (
    <select
      value={lang}
      onChange={(e) => setLang(e.target.value)}
      className="rounded-xl border border-slate-300 bg-white px-3 py-2 text-sm"
      aria-label="Language selector"
    >
      {LANGS.map((l) => (
        <option key={l.code} value={l.code}>{l.label}</option>
      ))}
    </select>
  );
}
